/** @jsxRuntime classic */
/** @jsx jsx */
import React from 'react'
import API from '/repository/repoAPI'
import { useSession } from 'next-auth/react'

import { jsx, Box, Image } from 'theme-ui'
import styles from './styles'
import EventGuideSection from '/components/Korea/EventGuideSection'
import PrizesSection from '/components/Korea/PrizesSection'
import TextBanner from '/components/Korea/TextBanner'
import UpperFooterSection from '/components/Korea/UpperFooterSection'
import FormSection from './components/FormSection'

const Event1Page = (props) => {
  const { layout, locale } = props.pageProps
  const { data: session, status } = useSession()
  const loading = status === 'loading'

  // Event master table it's not dynamic, it only has to be filled in once, contentful trigger boolean
  React.useEffect(() => {
    layout?.formSection?.populateEventMasterTable &&
      API.postEventMaster('')({
        body: {
          locale: locale,
          campaignData: {
            event_id: layout?.formSection?.eventId,
            campaign_code: layout?.formSection?.campaignCode,
            event_name: layout?.formSection?.eventName,
            event_start_date: layout?.formSection?.eventStartDate,
            event_end_date: layout?.formSection?.eventEndDate,
          },
          formData: layout?.formSection.optionalQuestions,
        },
      })
  }, [layout])

  return (
    <Box sx={styles.container}>
      {layout?.headerOpeningSection?.backgroundImageDesktop && (
        <Box sx={styles.imageContainer}>
          <Image
            sx={styles.headerImage}
            src={layout?.headerOpeningSection?.backgroundImageDesktop}
          />
          <Box sx={styles.overlay} />
        </Box>
      )}
      <EventGuideSection csmContent={layout?.eventGuideSection} />
      <PrizesSection cmsContent={layout?.prizesSection} />
      {!loading && (
        <FormSection
          cmsContent={layout?.formSection}
          session={session}
          locale={locale}
        />
      )}
      <TextBanner cmsContent={layout?.bannerSection} />
      <UpperFooterSection cmsContent={layout?.upperFooterSection} />
    </Box>
  )
}

export default Event1Page
